import React from "react"
import { Dialog, DialogContent, Box, IconButton, useTheme } from "@mui/material"
import { styled } from "@mui/system"
import AppButton from "components/StyledComponents/AppButton"
import { Close } from "@mui/icons-material"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.white.main,
    borderRadius: "8px"
  }
}))

const CommonModal = ({
  open,
  onClose = () => {},
  onSubmit,
  hideAction = false,
  actionButtons,
  maxWidth = "md",
  children,
  sx
}) => {
  const theme = useTheme()
  const style = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "15px",
      right: "15px",
      zIndex: 10,
      backgroundColor: theme.palette.background.main
    }
  }

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={maxWidth ?? "md"} fullWidth>
      <IconButton onClick={onClose} sx={style.closeBtn} size="small">
        <Close sx={{ height: 14, width: 14 }} />
      </IconButton>
      <DialogContent sx={sx}>{children}</DialogContent>
      {!hideAction &&
        (actionButtons ? (
          actionButtons
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
            <AppButton onClick={onClose}>Cancel</AppButton>
            <AppButton onClick={onSubmit}>Save</AppButton>
          </Box>
        ))}
    </StyledDialog>
  )
}

export default CommonModal
